export const ACTIVITY_1011_CONFIG_KEY = 'activity';
export const ACTIVITY_1011_CONFIG_MODULE = 'common';
export const ACTIVITY_1011_TASK_CONFIG_PERMISSION = 'Dramas_Activity-1011_Task-Config';
export const ACTIVITY_1011_TASK_CONFIG_UPDATE_PERMISSION = 'Dramas_Activity-1011_Task-Config_Update';

export const ACTIVITY_1011_CHECKIN_DAYS = 7;

/** 已知任务 type → 展示名（下拉与列表展示用） */
export const ACTIVITY_1011_TASK_TYPE_LABELS: Record<string, string> = {
    follow_x: '关注 X',
    retweet_x: '转发 X',
    like_x: '点赞 X',
    publish_drama: '发布短剧',
    watch_drama: '观看短剧',
    mining: '挖矿',
};

export const ACTIVITY_1011_SHARE_PLATFORMS = ['x', 'tiktok', 'youtube'] as const;

export const ACTIVITY_1011_METRIC_KEYS = ['play', 'like', 'retweet'] as const;
